module.exports = __webpack_public_path__ + "img/home-bg.cfae8b89.png";